import React from "react";

import HelpTooltip from "../../../../components/HelpTooltip";
import { convertIntToMoney } from "../../../../helpers/conversions";

/**
 * Cards de totais que também filtram a lista. `cards`:
 * [{ key, label, value, tone: 'income' | 'expense' | 'total', help }]
 *
 * O card com `key` nulo é o "sem filtro" (Total do período): clicar em um
 * card ativo também volta para ele.
 */
export const SummaryCards = ({ cards, active, onSelect, loading }) => (
    <div className="finance-summary-cards">
        {cards.map(card => {
            const isActive = (active || null) === card.key;

            return (
                <button
                    type="button"
                    key={card.key ?? 'total'}
                    className={`summary-card tone-${card.tone}${isActive ? ' active' : ''}`}
                    onClick={() => onSelect(isActive ? null : card.key)}
                >
                    <span className="summary-card-label">
                        {card.label}
                        {card.help && <HelpTooltip text={card.help} size={14} />}
                    </span>
                    <strong className="summary-card-value">
                        {loading ? '—' : convertIntToMoney(card.value ?? 0)}
                    </strong>
                </button>
            );
        })}
    </div>
);

export default SummaryCards;
